import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './navbar.css'; // You'll need to style nested dropdowns here
import logo from '../images/logo.png';
import { Link } from 'react-router-dom';

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg custom-navbar">
      <div className="container d-flex align-items-center justify-content-between">
        <Link className="navbar-brand d-flex align-items-center gap-2 text-light fw-bold" to="/">
          <img src={logo} alt="Logo" className="navbar-logo" />
          <span>
            OM Enterprises
            <br />
            {/* <small style={{ fontSize: "0.8rem" }}>Your Tagline</small> */}
          </span>
        </Link>

        <button
          className="navbar-toggler bg-light"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-center" id="navbarContent">
          <ul className="navbar-nav gap-4 text-center">
            <li className="nav-item">
              <Link className="nav-link text-light fw-semibold" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light fw-semibold" to="/about">About</Link>
            </li>

            {/* Products Dropdown with submenus */}
            <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle text-light fw-semibold"
                to="#"
                id="productsDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Products
              </Link>
              <ul className="dropdown-menu" aria-labelledby="productsDropdown">

                {/* Product 1 */}
                <li className="dropdown-submenu">
                  <Link className="dropdown-item dropdown-toggle" to="#">Turning</Link>
                  <ul className="dropdown-menu">
                    <li><Link className="dropdown-item" to="/Ifs">Inserts For Steel</Link></li>
                    <li><Link className="dropdown-item" to="/Ifss">Inserts For Stain Steel</Link></li>
                    <li><Link className="dropdown-item" to="/Ifci">Inserts For Cast Iron</Link></li>
                    <li><Link className="dropdown-item" to="/Ifa">Insert For Aluminium</Link></li>
                    <li><Link className="dropdown-item" to="/Ci">Cermet Inserts</Link></li>
                    <li><Link className="dropdown-item" to="/Pcd">PCD Inserts</Link></li>
                    <li><Link className="dropdown-item" to="/Cbn">CBN Inserts</Link></li>
                    <li><Link className="dropdown-item" to="/Th">Tool Holders</Link></li>
                    <li><Link className="dropdown-item" to="/Bb">Boring Bar</Link></li>
                  </ul>
                </li>

                {/* Product 2 */}
                <li className="dropdown-submenu">
                  <Link className="dropdown-item dropdown-toggle" to="#">Milling</Link>
                  <ul className="dropdown-menu">
                    <li><Link className="dropdown-item" to="/Fm">Face Milling</Link></li>
                    
                  </ul>
                </li>

                {/* Product 3 */}
                <li className="dropdown-submenu">
                  <Link className="dropdown-item dropdown-toggle" to="#">Threading</Link>
                  <ul className="dropdown-menu">
                    <li><Link className="dropdown-item" to="/Et">External Threading</Link></li>
                    <li><Link className="dropdown-item" to="/It">Internal Threading</Link></li>
                  </ul>
                </li>

                {/* Product 4 */}
                <li className="dropdown-submenu">
                  <Link className="dropdown-item dropdown-toggle" to="#">Grooving</Link>
                  <ul className="dropdown-menu">
                    <li><Link className="dropdown-item" to="/Circlip">Circlip</Link></li>
                    <li><Link className="dropdown-item" to="/Parting">Parting</Link></li>
                  </ul>
                </li>

                {/* Product 5 */}
                <li className="dropdown-submenu">
                  <Link className="dropdown-item dropdown-toggle" to="#">Drilling</Link>
                  <ul className="dropdown-menu">
                    <li><Link className="dropdown-item" to="/Spt">SB Type</Link></li>
                    
                  </ul>
                </li>

              </ul>
            </li>
  <li className="nav-item">
              <Link className="nav-link text-light fw-semibold" to="/Cata">Catalog</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light fw-semibold" to="/Enquiry">Enquiry</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light fw-semibold" to="/Gallery">Gallery</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link text-light fw-semibold" to="/Contact">Contact Us</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
